<script setup lang="ts">
import { computed, useTemplateRef } from "vue";

import { useBoardsStore } from "@/store/boards";

import BaseBacklogBoard from "./BaseBacklogBoard.vue";

defineExpose({ focus: () => void rootRef.value?.focus() });

const rootRef = useTemplateRef("root");

const board = computed(() => useBoardsStore().boardByType("backlog"));
</script>

<template>
  <BaseBacklogBoard
    ref="root"
    :board
    :aria-label="$t('board.backlog')"
    tabindex="0"
    @click="rootRef?.blur()"
  />
</template>
